import type { TourStep } from '../types';

export const billingSteps: TourStep[] = [
  {
    target: '[data-tour="billing-tab"]',
    title: 'Subscription & Billing',
    content:
      'Manage your Ashlar subscription, purchase credits, and review transaction history — all from this tab.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="billing-plan"]',
    title: 'Your Current Plan',
    content:
      'See your active plan, status, and renewal date. Upgrade, downgrade, or cancel from here. Changes take effect at the next billing cycle.',
    placement: 'bottom',
    spotlightClicks: true,
  },
  {
    target: '[data-tour="billing-credits"]',
    title: 'Credit Balance',
    content:
      'Credits power premium features — mileage reconstruction, market data reports, and AI tools. See your balance and available credit packs to purchase.',
    placement: 'bottom',
    isActionStep: true,
    spotlightClicks: true,
    nextButtonText: 'Got it',
  },
  {
    target: '[data-tour="billing-history"]',
    title: 'Transaction History',
    content:
      'A complete log of credit purchases, usage, and subscription payments. Use the filters to find specific transactions.',
    placement: 'top',
  },
  {
    target: '[data-tour="billing-portal"]',
    title: 'Stripe Portal',
    content:
      'For payment method changes, invoice downloads, and detailed billing management, the Stripe portal gives you full control over your payment account.',
    placement: 'bottom',
    isActionStep: true,
    spotlightClicks: true,
    nextButtonText: 'Open portal',
  },
];
